module.exports = "/static/assets/1c6e5129e936855db5a1181a778a3b94.svg";